enum PreNegotiationOriginEnum {
  ECONOMIC_GROUP = 'economic_group',
  CUSTOMER = 'customer',
  DOCUMENT = 'document',
}

export default PreNegotiationOriginEnum;
